import { useLocation } from 'react-router';

export function useCheckInAdmin() {
  const location = useLocation();
  return location.pathname.startsWith('/admin');
}
